import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { Student } from '@/types';
import { SUPPORT_PLAN_STATUS, YES_NO } from '../../StudentForm/constants';

interface SupportSectionProps {
  values: Partial<Student>;
  onChange: (id: keyof Student, value: any) => void;
}

export const SupportSection: React.FC<SupportSectionProps> = ({
  values,
  onChange
}) => {
  const handleChange = (field: keyof Student) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange(field, event.target.value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Support Services Received"
          value={values.supportServices || ''}
          onChange={handleChange('supportServices')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Community Referrals"
          value={values.communityReferrals || ''}
          onChange={handleChange('communityReferrals')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Educational Barriers"
          value={values.barriers || ''}
          onChange={handleChange('barriers')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Support Plan Status"
          value={values.supportPlanStatus || ''}
          onChange={handleChange('supportPlanStatus')}
        >
          {SUPPORT_PLAN_STATUS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Digital Access"
          value={values.digitalAccess || ''}
          onChange={handleChange('digitalAccess')}
        >
          {YES_NO.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};